import React from 'react';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import Products from '../../../services/products';
import ParseAvatar from '../../../components/ParseAvatar';

import moment from 'moment';

import "../styles/account.css";

function AccountDetail(props) {
  const actions = [
    <FlatButton
      label="Done"
      primary={true}
      onClick={props.onAccountDetailClose} />
  ];

  const user = props.user;

  return (
    <Dialog
      title="Account Details"
      actions={actions}
      modal={true}
      open={true}
      autoScrollBodyContent={true}
      onRequestClose={props.onAccountDetailClose}
      contentStyle={{width: '400px'}} >

      <div className="account-header">
        <ParseAvatar file={user.get('avatarData')} size={64} />
        <div className='account-header__names'>
          <h4>{user.get('givenName')} {user.get('familyName')}</h4>
          <p>{user.get('username')}</p>
        </div>
      </div>
      <div className='detail-item'>
        <p className='floating-label'>School</p>
        <p className='detail-item__title'>{user.get('school')}</p>
      </div>
      <div className='detail-item'>
        <p className='floating-label'>Grade</p>
        <p className='detail-item__title'>{user.get('grade')}</p>
      </div>
      <div className='detail-item'>
        <p className="floating-label">Subscription</p>
        <p className='detail-item__title'>{ Products.getProductTitle(user.get('subscriptionProductID')) }</p>
      </div>
      <div className='detail-item'>
        <p className='floating-label'>Expiration</p>
        <p className='detail-item__title'>{moment(user.get('subscriptionExpirationDate')).format('LL')}</p>
      </div>
      
    </Dialog>
  );
}

export default AccountDetail;


// WEBPACK FOOTER //
// ./src/scenes/Account/components/AccountDetail.js